<template>
    <v-dialog v-model="dialog" persistent width="auto">
        <v-card :loading="loading" class="pa-4 text-center" title="Doação para o carta moz"
            prepend-icon="mdi-hand-heart">
            <v-alert v-show="showMensage" :type="sucesseMensage ? 'success' : 'error'"
                :title="sucesseMensage ? 'sucesso' : '!!OPSHII.. ocorreu um Ero'" :text="sucesseMensage ? 'Muito obrigado por ativamente suportar o nosso projete. n/    Desejamos a continuação de um optimo dia e bons estudos'
        : 'Um erro ocoreu ao tentar doar para o carta moz. Volte a tentar em 5min '"></v-alert>

            <v-card-text>
                Ajude com um valor simbolico o nosso projeto
            </v-card-text>
            <v-form v-model="form">
                <v-text-field v-model="amount" variant="outlined" label="Valor" :rules="rules2" type="number"
                    suffix="Mtn"></v-text-field>
                <v-text-field v-model="phonenumber" variant="outlined" label="Numero do m-pesa" :rules="rules"
                    type="number" prefix="+258">
                </v-text-field>
                <v-text-field v-model="nome" label="Nome doador/a"
                    hint="Opcional(pode deixar em branco esse campo)"></v-text-field>
                <v-card-actions>
                    <v-btn :loading="loading" @click="donete" color="error" variant="elevated" :disabled="!form"
                        block>M-pesa</v-btn>
                </v-card-actions>
                <v-btn @click="closedialog" icon="mdi-alpha-x"></v-btn>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import axios from 'axios'
import { defineComponent, toRaw } from 'vue'
import DoacoesApi from '@/config/doacoes'
const api = new DoacoesApi();

export default defineComponent({
    name: '',
    props: { dialog: { type: Boolean, requeried: true } },
    data() {
        const rules = [(val: string) => !!val || 'Campo obrigatório',
        (val: string) => val.startsWith('84' || '85') || 'o numero deve iniciar com 84 ou 85',
        (val: string) => val.length === 9 || ''
        ]
        const phonenumber = ''
        const amount = ''
        const rules2 = [(val: string) => !!val || 'Campo obrigatório']

        return {
            phonenumber, amount,
            rules,
            rules2,
            form: false, nome: '',
            loading: false,
            showMensage: false,
            sucesseMensage: false

        }
    },
    methods: {
        closedialog() {
            this.showMensage = false
            this.$emit('refuse')
        },
        async donete() {
            this.loading = true
            try {
                const result = await axios.post('https://96yixq0fh9.execute-api.us-east-2.amazonaws.com/default', {
                    phoneNumber: `258${this.phonenumber}`,
                    amount: `${this.amount}`
                });

                if (result.status === 200 || result.status === 201) {
                    console.log('Success:', result.data);
                    this.showMensage = true
                    this.loading = false
                    this.sucesseMensage = true
                    api.insertItem({
                        id: 0,
                        name: this.nome,
                        value: +this.amount
                    })
                } else {
                    this.showMensage = true
                    this.sucesseMensage = false
                    this.loading = false
                }

                return result;
            } catch (error) {
                this.showMensage = true
                this.sucesseMensage = false
                this.loading = false
                throw error
            }


        }
    }
})
</script>
